import { render, staticRenderFns } from "./ConstructionTypeTable.vue?vue&type=template&id=282bf77b&"
import script from "./ConstructionTypeTable.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTypeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports